module.exports = __webpack_public_path__ + "img/select.200bd6ac.svg";